import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

import Heading from '@bibliocommons/heading';
import { catalogBibShape, listShape, userIdentityShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { SecondaryGhostLink } from '@bibliocommons/base-links';

import ListsRow from './ListsRow';

import './StaffLists.scss';

export default class StaffLists extends React.PureComponent {
  renderAllListsLink() {
    const { catalogBib } = this.props;
    const metadataId = catalogBib.get('metadataId');

    return (
      <SecondaryGhostLink
        className="cp-all-lists-link"
        dataKey="all-lists-link"
        href={`/v2/record/${metadataId}/lists`}
      >
        <FormattedMessage id="view_all_lists" />
      </SecondaryGhostLink>
    );
  }

  renderLists() {
    const { lists, library, users, handleListTitleClick, handleListImageClick, handleListImpression } = this.props;

    if (lists.size <= 2) {
      return (
        <div>
          <Heading tagName="h2" size="moderate" variant className="staff-lists-heading">
            <FormattedMessage id="staff_lists_featuring_title" />
          </Heading>
          <ListsRow
            lists={lists}
            stacked
            users={users}
            library={library}
            handleListTitleClick={handleListTitleClick}
            handleListImageClick={handleListImageClick}
            handleListImpression={handleListImpression}
          />
        </div>
      );
    }

    return (
      <div>
        <Heading tagName="h2" size="moderate" variant className="staff-lists-heading">
          <FormattedMessage id="staff_lists_featuring_title" />
        </Heading>
        <ListsRow
          key="desktop"
          className="lists-desktop"
          lists={lists.take(4)}
          library={library}
          users={users}
          handleListTitleClick={handleListTitleClick}
          handleListImageClick={handleListImageClick}
          handleListImpression={handleListImpression}
        />
        <ListsRow
          key="mobile"
          className="lists-mobile"
          lists={lists}
          stacked
          library={library}
          users={users}
          handleListTitleClick={handleListTitleClick}
          handleListImageClick={handleListImageClick}
          handleListImpression={handleListImpression}
        />
      </div>
    );
  }

  render() {
    const { lists } = this.props;
    if (!lists.size) return null;

    return (
      <div className="cp-staff-lists">
        {this.renderLists()}
        <div className="view-all-link">{this.renderAllListsLink()}</div>
      </div>
    );
  }
}

StaffLists.propTypes = {
  catalogBib: catalogBibShape,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  library: libraryShape,
  handleListTitleClick: PropTypes.func,
  handleListImageClick: PropTypes.func,
  handleListImpression: PropTypes.func
};
